import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { antColors } from '@frontend/constants/colors';
import styles from './TruoraAlertNoStock.module.scss';

const TruoraAlertNoStock = () => {
  return (
    <div className={styles.alert}>
      <FontAwesomeIcon icon={faTriangleExclamation} color={antColors.yellow3} />
      <span>
        <strong>
          Has agotado tu plan de evaluaciones de antecedentes con Truora.
        </strong>{' '}
        Si deseas solicitar más información contáctate con tu ejecutivo
        comercial.
      </span>
    </div>
  );
};

export default TruoraAlertNoStock;
